const API_URL = "https://www.chemcoats.com";
// const API_URL = "http://103.14.120.38:4002";
//const API_URL = "http://51.20.71.183:4002/";
//const API_URL = "https://blog.revnitro.com";

export default API_URL;
